import { checkEnvironment } from '@saviynt/common';

const getPlatformTypeApiUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/endpoints/platformtypes`;
};

export default getPlatformTypeApiUrl;
